import { combineReducers } from "redux";

// Import custom components
import productReducer from "./products";
import categoryReducer from "./categories";
import industryReducer from "./industries";
import cartReducer from "./cart";
import searchReducer from "./search";
import ordersReducer from "./orders";
import wishlistReducer from "./wishlist";
import compareReducer from "./compare";
import filterReducer from "./filter";
import modalReducer from "./modal";
import userReducer from "./User";
import userNameReducer from "./UserName";
const rootReducer = combineReducers({
  data: productReducer,
  cartlist: cartReducer,
  wishlist: wishlistReducer,
  compare: compareReducer,
  filters: filterReducer,
  modal: modalReducer,
  user: userReducer,
  userName: userNameReducer,
  data2: categoryReducer,
  orderData: ordersReducer,
  dataIndustry: industryReducer,
  search: searchReducer,
});

export default rootReducer;
